export const Options = {
    Salutation: [
        { text: "männlich", value: "M" },
        { text: "weiblich", value: "W" },
        { text: "divers", value: "D" },
    ]
}
